<div class="tooltip-icon-container">
  <i
    class="icon icon-{{ iconName }}"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
  </i>
  <div
    class="tooltip-content {{ position }} fade"
    [class.in]="!hideTooltip"
    (mouseleave)="onMouseLeave()"
  >
    <ng-content></ng-content>
  </div>
</div>
